import React from "react";
import { FormVariations } from "@/context/FormDataContext";
import { FormStepperContainer } from "./styles";

interface IFormStepper {
  currentStep: number;
  variation: FormVariations;
  stepList: Array<IFormStep>;
}

export interface IFormStep {
  all?: React.JSX.Element;
  partner?: React.JSX.Element;
  partnerWithStatement?: React.JSX.Element;
  workable?: React.JSX.Element;
  nonworkable?: React.JSX.Element;
}

/**
 * @arg props
 * @returns the FormStepper component
 */
export default function FormStepper(props: IFormStepper): React.JSX.Element {
  const stepModule = props.stepList[props.currentStep][props.variation];
  return <FormStepperContainer>{stepModule}</FormStepperContainer>;
}
